import type { HotelFare } from './searchModel';

/** Display labels never participate in routing or fare identity. */
export function hotelProviderLabel(connector: string | undefined, name: string | null | undefined, code: string | null | undefined, unknown: string): string {
  const provider = name || (connector === 'hotelbeds' ? 'Hotelbeds' : code) || unknown;
  const via = connector === 'hotelbeds' ? 'direct' : !connector || connector === 'travelgate' ? 'tgx' : connector;
  return `${provider} - ${via}`;
}

export function hotelFareProviderLabel(fare: HotelFare, unknown: string): string {
  return hotelProviderLabel(fare.connector_lineage.connector, fare.supplier_display_name, fare.connector_lineage.supplier_code, unknown);
}

export function hotelFareProviderKey(fare: HotelFare): string {
  return JSON.stringify([fare.connector_lineage.connector ?? 'travelgate', fare.connector_lineage.supplier_code ?? null]);
}
